/**
 * Stable CSS class names for E2E — SummaryAggregation NetSales page.
 */
export const NS = {
    page: 'net-sales-page',
    root: 'net-sales',

    breadcrumb: 'net-sales__breadcrumb',
    titleIcon: 'net-sales__title-icon',
    loading: 'net-sales__loading',

    list: 'net-sales__list',
    listSearchBar: 'net-sales__list-search-bar',
    listSearchLabel: 'net-sales__list-search-label',
    listDateRanger: 'net-sales__list-date-ranger',
    dateRange: 'net-sales-input--date-range',
    btnSearch: 'net-sales-input--button-search',

    listGridContainer: 'net-sales__list-grid-container',
    listGrid: 'net-sales__list-grid',
    listNoRecord: 'net-sales__list-no-record',

    statusChip: 'net-sales__status-chip',
    statusChipPendingAccounting: 'net-sales__status-chip--pending-accounting',
    statusChipAccountingComplete: 'net-sales__status-chip--accounting-complete',
    statusChipTransferComplete: 'net-sales__status-chip--transfer-complete',
    statusChipNeedRecalculate: 'net-sales__status-chip--need-recalculate',
} as const;

export const nsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
